import Vue from "vue";
import App from "./App.vue";
import VButton from "./components/elements/Button";
import router from "./router";
import "./utils/fonts";
import store from "./store";
import axios from "axios";

Vue.config.productionTip = false;

Vue.prototype.$http = axios;
Vue.prototype.$http.interceptors.request.use(
  (config) => {
    // Authorization header removed; backend relies on http-only cookies now.
    return config;
  },
  (error) => Promise.reject(error)
);

router.beforeEach(async (to, from, next) => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next();
    return;
  }
  // Ensure we attempted to load session once
  await store.dispatch("authentication/ensureSession");
  if (!store.getters["authentication/isAuthenticated"]) {
    if (to.path !== "/login") {
      return next("/login");
    }
  }
  next();
});

Vue.component("VButton", VButton);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
